import {
  store
} from '@/store'
import axiosInstances from '@/../../coreui/server/axiosInstances'

function trim(v) {
  let ll = 12
  if (v.length <= ll) return v
  var lx = ll - 3
  return v.substring(0, 3) + '...' + v.slice(3 - lx)
}

async function getHarvests() {
  let res = await axiosInstances.apiServer.get('/dt/v1/cul_harvest?IsUsed=yes&return=wet&return=name&return=count')
  if (res == null || res.data == null) return ({
    labels: [],
    values: []
  })
  let data = res.data.map(i => {
    i.wet.qty = parseFloat(i.wet != undefined ? i.wet.qty : 0)
    i.count = parseInt(i.count == undefined || i.count == '' ? '0' : i.count)
    return i
  })
  data.sort((a, b) => a.wet.qty > b.wet.qty ? -1 : 1)
  console.log ('DATA: ', data)
  let labels = data.map(i => i.name)
  let values = data.map(i =>  i.wet.qty )
  let counts = data.map(i => i.count )
  let totalWeight = data.reduce((total, i) => {
    if (i && i.wet && i.wet.qty) {
      return total + i.wet.qty
    } else {
      return total
    }
  }, 0)

  let totalCount = data.reduce((total, i) => {
    return total + i.count
  }, 0)
  let countlabels = data.map(i => i.name)
  return {
    labels: labels,
    values: values,
    counts: counts,
    countlabels: countlabels,
    totalWeight: totalWeight,
    totalCount: totalCount,
    weightUnit: res.data[0] ? res.data[0].wet.unit : ''
  }
}

async function getTrims() {
  // let res = await axiosInstances.apiServer.get('/dt/v1/cul_trim?IsUsed=yes&return=wet&return=name&return=favail&return=savail&return=tavail')
  let res = await axiosInstances.apiServer.get('/dt/v1/cul_trim?IsUsed=yes')
  if (res == null || res.data == null) return ({
    labels: [],
    values: [],
    fvalues: [],
    svalues: [],
    tvalues: []
  })
  // console.log('trim:', res.data)
  let labels = res.data.map(i => i.name)
  let fvalues = res.data.map(i => parseFloat(i.flower != undefined ? i.flower.qty : 0))
  let svalues = res.data.map(i => parseFloat(i.smalls != undefined ? i.smalls.qty : 0))
  let tvalues = res.data.map(i => parseFloat(i.trim != undefined ? i.trim.qty : 0))
  let totalFlowerWeight = res.data.reduce((total, i) => {
    return total + parseFloat(i.flower != undefined ? i.flower.qty : 0)
  }, 0)
  let totalSmallsWeight = res.data.reduce((total, i) => {
    return total + parseFloat(i.smalls != undefined ? i.smalls.qty : 0)
  }, 0)
  let totalTrimWeight = res.data.reduce((total, i) => {
    return total + parseFloat(i.trim != undefined ? i.trim.qty : 0)
  }, 0)
  return {
    labels,
    fvalues,
    svalues,
    tvalues,
    totalFlowerWeight,
    totalSmallsWeight,
    totalTrimWeight,
    flowerWeightUnit: (res && res.data[0] && res.data[0].flower) ? res.data[0].flower.unit : '',
    smallsWeightUnit: (res && res.data[0] && res.data[0].smalls) ? res.data[0].smalls.unit : '',
    trimWeightUnit: (res && res.data[0] && res.data[0].trim) ? res.data[0].trim.unit : ''
  }
}

async function getStrains() {
  let pipe = [{
      "$match": {
        "IsUsed": {
          "$ne": "no"
        }
      }
    },
    {
      "$project": {
        "strain_id": {
          "$toObjectId": "$strain"
        },
        "document": "$$ROOT"
      }
    },
    {
      "$lookup": {
        "from": "set_strain",
        "localField": "strain_id",
        "foreignField": "_id",
        "as": "planting_strain"
      }
    },
    {
      "$project": {
        "planting_name": {
          "$arrayElemAt": ["$planting_strain.name", 0]
        },
        "doc": "$document"
      }
    },
    {
      "$group": {
        "_id": "$planting_name",
        "Flowering": {
          "$sum": {
            "$cond": [{
              "$eq": ["$doc.phase", "Flowering"]
            }, 1, 0]
          }
        },
        "Vegetative": {
          "$sum": {
            "$cond": [{
              "$eq": ["$doc.phase", "Vegetative"]
            }, 1, 0]
          }
        },
        "Dead": {
          "$sum": {
            "$cond": [{
              "$eq": ["$doc.phase", "Dead"]
            }, 1, 0]
          }
        },
        "Destroyed": {
          "$sum": {
            "$cond": [{
              "$eq": ["$doc.phase", "Destroyed"]
            }, 1, 0]
          }
        }
      }
    }
  ]
  let res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plants&op=pipe', pipe)
  if (res == null || res.data == null) return ({
    labels: [],
    values: []
  })
  let labels = res.data.map(i => i._id)
  let fvalues = res.data.map(i => i.Flowering)
  let vvalues = res.data.map(i => i.Vegetative)
  let dvalues = res.data.map(i => i.Dead)
  let xvalues = res.data.map(i => i.Destroyed)
  let totalCount = res.data.reduce((sum, i) => {
    return sum + i.Flowering + i.Vegetative
  }, 0)
  return {
    labels,
    fvalues,
    vvalues,
    dvalues,
    xvalues,
    totalCount
  }

}

async function getPlantings() {
  let pipe = [{
      "$match": {
        "IsUsed": {
          "$ne": "no"
        }
      }
    },
    {
      "$project": {
        "strain_id": {
          "$toObjectId": "$strain"
        },
        "live": "$live",
        "dead": "$dead"
      }
    },
    {
      "$lookup": {
        "from": "set_strain",
        "localField": "strain_id",
        "foreignField": "_id",
        "as": "planting_strain"
      }
    },
    {
      "$project": {
        "planting_name": {
          "$arrayElemAt": ["$planting_strain.name", 0]
        },
        "live": 1,
        "dead": 1
      }
    },
    {
      "$group": {
        "_id": "$planting_name",
        "live": {
          "$sum": {
            "$convert": {
              "input": "$live",
              "to": "double",
              "onError": 0,
              "onNull": 0
            }
          }
        },
        "dead": {
          "$sum": {
            "$convert": {
              "input": "$dead",
              "to": "double",
              "onError": 0,
              "onNull": 0
            }
          }
        }
      }
    }
  ]

  let res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plantings&op=pipe', pipe)
  if (res == null || res.data == null) return ({
    labels: [],
    values: []
  })
  let s = res.data.map((i) => {
    return {
      'name': i._id,
      'live': i.live,
      'dead': i.dead
    }
  })
  let labels = s.reduce((total, i) => {
    total.push(i.name)
    return total
  }, [])
  let live = s.reduce((total, i) => {
    total.push(i.live)
    return total
  }, [])
  let dead = s.reduce((total, i) => {
    total.push(i.dead)
    return total
  }, [])
  return {
    labels,
    live,
    dead
  }
}

async function getCompliance(org) {
  console.log('Getting compliance for org ', org)
  if (org == 'CultivationDemo') {
    return {
      count: 1267,
      unsynced: 320,
      waiting: 42,
      plants: 1243,
      plantings: 10,
      packages: 14,
      total: 198792,
      history: {
        dates: [
          '06/04/2021 GMT', '06/05/2021 GMT',
          '06/06/2021 GMT', '06/07/2021 GMT',
          '06/08/2021 GMT', '06/09/2021 GMT',
          '06/10/2021 GMT', '06/11/2021 GMT',
          '06/12/2021 GMT', '06/13/2021 GMT',
          '06/14/2021 GMT', '06/15/2021 GMT',
          '06/16/2021 GMT', '06/17/2021 GMT'
        ],
        values: [{
          name: 'Plants',
          data: [235, 0, 0, 198, 0, 0, 0, 0, 120, 180, 0, 0, 0, 225]
        }, {
          name: 'Plantings',
          data: [22, 0, 0, 0, 3, 7, 0, 0, 0, 0, 0, 8, 12, 0]
        }, {
          name: 'Packages',
          data: [4, 2, 9, 0, 5, 22, 7, 6, 2, 0, 0, 1, 7, 12]
        }]
      }
    }
  }
  let plants, plantings, packages, unsynced, waiting, total
  let unsyncedPlants, unsyncedPlantings, unsyncedPackages
  let waitingPlants, waitingPlantings, waitingPackages
  let pipe = [{
      "$match": {
        "IsUsed": {
          "$ne": "no"
        }
      }
    },
    {
      '$facet': {
        total: [{
          $count: "count"
        }]
      }
    },

  ]
  let pipe2 = [{
      "$match": {
        "IsUsed": {
          "$ne": "no"
        }
      }
    },
    {
      "$match": {
        "mid": {
          "$exists": false
        }
      }
    },
    {
      "$facet": {
        "total": [{
          "$count": "count"
        }]
      }
    }
  ]
  let pipe3 = [{
      "$match": {
        "IsUsed": {
          "$ne": "no"
        }
      }
    },
    {
      "$match": {
        "mid": {
          "$$exists": true
        }
      }
    },
    {
      "$match": {
        "msync": {
          "$eq": "no"
        }
      }
    },
    {
      "$facet": {
        "total": [{
          "$count": "count"
        }]
      }
    }
  ]

  let pipe4 = [{
      "$match": {
        "mid": {
          "$exists": true
        }
      }
    },
    {
      "$facet": {
        "total": [{
          "$count": "count"
        }]
      }
    }
  ]
  let res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plants&op=pipe', pipe)
  plants = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plantings&op=pipe', pipe)
  plantings = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_packages&op=pipe', pipe)
  packages = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  // unsynced
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plants&op=pipe', pipe2)
  unsyncedPlants = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plantings&op=pipe', pipe2)
  unsyncedPlantings = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_packages&op=pipe', pipe2)
  unsyncedPackages = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  unsynced = unsyncedPlants + unsyncedPlantings + unsyncedPackages
  // waiting
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plants&op=pipe', pipe3)
  waitingPlants = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plantings&op=pipe', pipe3)
  waitingPlantings = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_packages&op=pipe', pipe3)
  waitingPackages = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  waiting = waitingPlants + waitingPlantings + waitingPackages

  res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_plants&op=pipe', pipe4)
  total = (res == null || res.data == null || res.data[0].total.length == 0) ? 0 : res.data[0].total[0].count
  return {
    count: plants + plantings + packages,
    unsynced,
    waiting,
    plants,
    plantings,
    packages,
    total
  }
}

async function getHarvestTimelines() {
  let pipe = [{
      "$match": {
        "$expr": {
          "$and": [{
            "$ne": ["$IsUsed", "no"]
          }]
        }
      }
    },
    {"$limit": 10},
    {
      "$project": {
        "name": 1,
        "wet": 1,
        "hcount": "$count"
      }
    },
    {
      "$lookup": {
        "from": "cul_plants",
        "localField": "name",
        "foreignField": "harvestName",
        "as": "test"
      }
    },
    {
      "$unwind": "$test"
    },
    {
      "$project": {
        "name": 1,
        "wet": 1,
        "hcount": 1,
        "harvested": {
          "$dateToString": {
            "format": "%Y-%m-%d",
            "date": {
              "$dateFromString": {
                "dateString": "$test.harvested"
              }
            }
          }
        },
        "planted": {
          "$dateToString": {
            "format": "%Y-%m-%d",
            "date": {
              "$dateFromString": {
                "dateString": "$test.planted"
              }
            }
          }
        },
        "flowered": {
          "$dateToString": {
            "format": "%Y-%m-%d",
            "date": {
              "$dateFromString": {
                "dateString": "$test.flowered"
              }
            }
          }
        }
      }
    },

    {
      "$group": {
        "_id": {
          "planted": "$planted",
          "flowered": "$flowered",
          "harvested": {
            "$dateFromString" : {"dateString" :"$harvested"}
          },
          "name": "$name",
          "wet" : "$wet",
          "hcount" : "$hcount"
        },
        // "count": {
        //   "$sum": 1
        // }
      }
    },
    {"$project": {
      "harvested": "$_id.harvested", 
      "hcount": 1,
      "wet": 1
    }},
    {"$sort": {"harvested": -1}}
  ]
  let res = await axiosInstances.apiServer.post('/misc/dbops?c=cul_harvest&op=pipe', pipe)
  console.log('RES: ', res)
  if (res == null || res.data == null ) return []
  let series = []
  let vegetative = []
  let flowering = []
  let extra = []
  res.data.forEach((i) =>{
    vegetative.push ({
      x: i['_id']['name'],
      y: [
        new Date(i['_id']['planted']).getTime(),
        new Date(i['_id']['flowered']).getTime()
      ]
    })
    flowering.push ({
      x: i['_id']['name'],
      y: [
        new Date(i['_id']['flowered']).getTime(),
        new Date(i['_id']['harvested']).getTime()
      ]
    })
    extra.push({count: i['_id']['hcount'], weight: i['_id']['wet']})
  })
  series.push({name: 'vegetative', data: vegetative})
  series.push({name: 'flowering', data: flowering})
  console.log({data: series, extra: extra})
  return {data: series, extra: extra}
}

function aReduce(ar) {
  if (!Array.isArray(ar)) return 0
  return ar.reduce((total, i) => {
    return total + parseFloat(i.toString())
  }, 0)
}

export default {
  getHarvests,
  getStrains,
  getTrims,
  getPlantings,
  getCompliance,
  getHarvestTimelines
}

// get all harvest names in active harvests
// [
//   {"$match": {  "$expr": {
//     "$and": [
//       {"$ne": ["$IsUsed", "no"]}
//     ]
//   }}}
// ]

// get all harvest timelines
// [


//   {"$match": {  "$expr": {
//    "$and": [
//        {"$ne": ["$IsUsed", "yes"]},

//        {"$gt": ["$harvested", null]}
//    ]
//  }
//  }},
//  {"$project" : {"harvest": "$harvestName", "planted": "$planted", "flowered": "$flowered" , "harvested": "$harvested"}},
//  {"$group": {
//  "_id": {
//      "planted": "$planted",
//      "flowered": "$flowered",
//      "harvested": "$harvested",
//      "name": "$harvest"
//  },
//  "count": { "$sum": 1 }
// }}

// ]